import { useEffect, useState } from 'react';
import { useDashboardBanner, useUpdateDashboardBanner } from '@/api/hooks';
import { useToast } from '@/components/Toast';

// SS14: admin Settings. Currently the Dashboard banner (toggle + message); more
// settings can be added here. The route is admin-guarded in App.tsx.
export function Settings() {
  const { data: banner } = useDashboardBanner();
  const update = useUpdateDashboardBanner();
  const notify = useToast();
  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    if (banner) { setEnabled(banner.enabled); setMessage(banner.message); }
  }, [banner]);

  async function save() {
    try {
      await update.mutateAsync({ enabled, message });
      notify('success', 'Settings saved.');
    } catch {
      notify('error', 'Could not save settings.');
    }
  }

  return (
    <div className="w-full max-w-3xl space-y-4 p-6">
      <div className="card space-y-3">
        <div>
          <h2 className="text-lg font-semibold text-foreground">Dashboard Banner</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            A temporary banner shown at the top of the Dashboard for everyone — e.g. to remind
            users not to submit New Client or New Engagement requests during busy season.
          </p>
        </div>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
          Show the banner on the Dashboard
        </label>
        <div>
          <label className="label">Banner message</label>
          <textarea
            className="input"
            rows={3}
            maxLength={500}
            placeholder="e.g. Please hold off on submitting New Client / New Engagement requests this week (busy season)."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <div>
          <button className="btn-success" disabled={update.isPending} onClick={save}>
            {update.isPending ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
